import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const RoleBasedRedirect: React.FC = () => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Перенаправляем в зависимости от роли
  switch (user.role) {
    case 'admin':
    case 'ae':
    case 'employee':
      return <Navigate to="/companies" />;
    case 'client':
      return <Navigate to="/client-dashboard" />;
    case 'csm':
      return <Navigate to="/transactions" />;
    default:
      return <Navigate to="/companies" />;
  }
};

export default RoleBasedRedirect;